import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/kyc.py KycSummaryOut.
export interface KycSummary {
  kyc_id: number;
  usr_id: number;
  legal_first_name: string;
  legal_last_name: string;
  business_type: string;
  business_name: string | null;
  status: string;
  created_at: string | null;
}

export interface KycDocument {
  kyc_document_id: number;
  document_type: string;
  original_filename: string;
  mime_type: string;
  file_size: number;
}

// Mirrors KycDetailOut — KycSummary plus the full PII payload.
export interface KycDetail extends KycSummary {
  date_of_birth: string | null;
  ssn_last4: string | null;
  address_line1: string | null;
  city: string | null;
  state: string | null;
  zip_code: string | null;
  country: string | null;
  ein: string | null;
  use_case: string | null;
  call_volume_estimate: string | null;
  reviewer_note: string | null;
  documents: KycDocument[];
}

export async function listKyc(statusFilter?: string): Promise<KycSummary[]> {
  const resp = await api.get<APIResponse<KycSummary[]>>("/kyc/", {
    params: statusFilter ? { status_filter: statusFilter } : undefined,
  });
  return unwrap(resp.data);
}

export async function getKyc(id: number): Promise<KycDetail> {
  const resp = await api.get<APIResponse<KycDetail>>(`/kyc/${id}`);
  return unwrap(resp.data);
}

export async function reviewKyc(
  id: number,
  body: { status: string; reviewer_note: string },
): Promise<void> {
  await api.put(`/kyc/${id}/review`, body);
}
